<template>
  <div v-if="!isLoadingData">
    <div class="d-flex justify-content-between p-3 p-sm-0 mb-3">
      <h1 class="mb-0 header-main text-uppercase d-inline">Role</h1>
    </div>
    <div class="bg-white-border p-3 text-black main-theme">
      <b-table
        responsive
        class="table-list"
        :items="items"
        :fields="fields"
        :busy="isBusy"
        show-empty
        :empty-text="$t('noData')"
      >
        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(roleName)="data">
          <p class="role-name">
            {{ data.index + 1 }}. {{ data.item.roleName }}
          </p>
          <div v-for="(role, i) in data.item.menu" v-bind:key="i">
            <p class="permission-name">- {{ role.name }}</p>
            <div
              v-for="(subRole, j) in role.subMenu"
              v-bind:key="j"
              :class="[
                { 'd-none': !form[data.index].permissionIds.includes(role.id) },
              ]"
            >
              <p class="permission-name pl-4">- {{ subRole.name }}</p>
            </div>
          </div>
        </template>
        <template v-slot:cell(id)="data">
          <br />
          <div v-if="form[data.index]">
            <b-form-group class="mb-0" v-slot="{ ariaDescribedby }">
              <b-form-checkbox-group
                v-model="form[data.index].permissionIds"
                :aria-describedby="ariaDescribedby"
                stacked
              >
                <div v-for="(role, i) in data.item.menu" v-bind:key="i">
                  <b-form-checkbox :value="role.id"> </b-form-checkbox>
                  <div
                    v-for="(subRole, j) in role.subMenu"
                    v-bind:key="j"
                    :class="[
                      {
                        'd-none': !form[data.index].permissionIds.includes(
                          role.id
                        ),
                      },
                    ]"
                  >
                    <b-form-checkbox :value="subRole.id"> </b-form-checkbox>
                  </div>
                </div>
              </b-form-checkbox-group>
            </b-form-group>
          </div>
        </template>
      </b-table>
      <b-row>
        <b-col cols="12" class="text-sm-right">
          <button
            type="button"
            @click="handleSubmit()"
            :disabled="isDisable"
            class="btn btn-main btn-details-set ml-md-2 text-uppercase"
          >
            SAVE
          </button>
        </b-col>
      </b-row>
    </div>
    <ModalLoading ref="modalLoading" :text="msgModal" :hasClose="false" />
  </div>
</template>

<script>
import ModalLoading from "@/components/modal/alert/ModalLoading";

export default {
  components: { ModalLoading },
  data() {
    return {
      isLoadingData: false,
      isDisable: false,
      msgModal: null,
      isBusy: false,
      fields: [
        {
          key: "roleName",
          label: "Chat Permission",
          tdClass: "text-left",
        },
        {
          key: "id",
          label: "Accessibility",
          class: "mw-250px",
        },
      ],
      form: [],
      items: [
        {
          roleName: "Team Admin",
          menu: [
            // { name: "menu", id: 1, value: false, subMenu: [] },
          ],
        },
        {
          roleName: "Agent",
          menu: [],
        },
      ],
    };
  },
  async mounted() {
    await this.getData();
  },
  methods: {
    async getData() {
      this.isLoadingData = true;
      this.isBusy = true;
      await this.axios
        .get(`${this.$baseUrl}/Permission/get-master-permission`)
        .then(async (data) => {
          if (data.result == 1) {
            this.items = data.detail;
            await this.items.forEach(async (item) => {
              let flltered = await item.menu.filter((item) => item.value);
              let permissionIds = flltered.map((item) => item.id);
              await item.menu.forEach(async (menu) => {
                let subFlltered = await menu.subMenu.filter(
                  (item) => item.value
                );
                let subPermissionIds = subFlltered.map((item) => item.id);
                permissionIds = [...permissionIds, ...subPermissionIds];
              });
              this.form.push({
                roleId: item.roleId,
                permissionIds: permissionIds,
              });
            });
            this.isLoadingData = false;
            this.isBusy = false;
          } else {
            this.isLoadingData = false;
            this.isBusy = false;
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.detail,
            });
          }
        })
        .catch((err) => {
          this.isDisabled = false;
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: err.message,
          });
        });
    },
    async handleSubmit() {
      this.$store.commit("UPDATE_MAIN_LOADING", true);
      this.isDisabled = true;
      let body = JSON.parse(JSON.stringify(this.form));
      await this.axios
        .post(`${this.$baseUrl}/Permission/update-master-permission`, body)
        .then((data) => {
          this.$store.commit("UPDATE_MAIN_LOADING", false);
          this.isDisabled = false;
          if (data.result == 1) {
            this.$store.dispatch("flowBuilder/fetchLogoBrand");
            this.getData();
            this.$store.commit("UPDATE_GLOBAL_ALERT", {
              isShow: true,
              msg: data.message,
            });
          } else
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.detail,
            });
        })
        .catch((err) => {
          this.isDisabled = false;
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: err.message,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.role-name {
  margin-bottom: 0;
  font-weight: bold;
}
.permission-name {
  margin-bottom: 0;
  text-indent: 30px;
}
::v-deep .table-list {
  thead tr th {
    border: 1px solid #d8dbe0;
  }
  tbody tr td {
    border: 1px solid #d8dbe0;
  }
}
</style>
